import React, { 
  useState, 
  useEffect, 
  createContext,
  useRef
} from 'react'
import { 
  Outlet, 
  useParams, 
  useNavigate,
  useOutletContext
} from 'react-router-dom'
import { useGame, useEventData, useUser } from 'data/hooks'

import { Content } from 'basecomps'

export const Event = (props) => {
  const { userId } = useUser()
  const { eventId } = useParams()
  const gameId = useParams().gameId || playmotiv.game.gameId
  const { events, user } = useGame(gameId)
  const event = events[eventId]
  const eventData = useEventData(gameId, eventId)
  const { instance } = eventData
  const navigate = useNavigate()

  useEffect(() => {

    if (!gameId) return
    if (!eventId) return
    eventData.refresh()

  }, [gameId, eventId])

  useEffect(() => {

    if (!instance) return

    window.playmotiv.context = {
      gameId: gameId,
      eventId: eventId,
      instanceId: instance.instanceId,
      wpId: event.wpId,
      player: user.players[0],
      onEnd: props.onend || (() => {}),
      // onEnd: () => console.log('Final de los finales desde el player!'),
      eventData: eventData
    }

  }, [eventData])
  
  // TODO: Puede que llegue a esta página para un evento que no tiene
  // ninguna instáncia (aún no se ha iniciado)
  // opciones:
  //    - mostrar un mensaje genérico (tipo error)
  //    - hacer un redirect
  //    - mostrar el content y habilitar visibility rules en base a event_not_start
  
  return <div
    className={`event ${(event && event.eventType) || ''}`}
  >
    { 
      event && 
      instance && 
      event.wpId && 
      <>
        <Content url={event.wpId} />
        <Outlet />
      </>
    }
  </div>
}
